export default __webpack_public_path__ + "static/media/LogoWhite.28e501b3.svg";